export default {
    title: "Weryfikacja adresu",
    header: "@:views.address.verified.title",
    message: "Dziękujemy za zweryfikowanie adresu. Możesz teraz wybrać ten adres jako adres wysyłki podczas składania zamówienia.",
}